export const SET_TYPE_PROFIL = 'SET_TYPE_PROFIL';
export const SET_TYPE_CONDITION = 'SET_TYPE_CONDITION';
export const SET_MULTIMODAL = 'SET_MULTIMODAL';
export const SET_TYPE_DATE = 'SET_TYPE_DATE';
export const SET_TIME = 'SET_TIME';

export const setProfil = profil => {
  return {
    type: SET_TYPE_PROFIL,
    payload: profil
  };
};

export const setCondition = condition => {
  return {
    type: SET_TYPE_CONDITION,
    payload: condition ? condition : 'Nothing'
  };
};

export const setMultimodal = multimodal => {
  return {
    type: SET_MULTIMODAL,
    payload: multimodal
  };
};

export const setTypeDate = typeDate => {
  return {
    type: SET_TYPE_DATE,
    payload: typeDate
  };
};

export const setTime = time => {
  return {
    type: SET_TIME,
    payload: time
  };
};
